<script>
import Layout from "./Layout.vue";

export default {
  props: {
    ui: {
      required: true,
    },
    topbarControls: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false,
    },
  },
  components: {
    Layout,
  },
};
</script>
<template>
  <div v-if="ui" class="p-0">
    <Layout
      v-for="(item, index) in ui"
      :key="index"
      :layout="item"
      :setTopbarControls="setTopbarControls"
      :topbarControls="topbarControls"
    />
  </div>
  <div v-else class="row m-5">
    <div class="col-12">
      <b-card bg-variant="danger" class="text-white-50">
        <h5 class="mt-0 mb-4 text-white">
          <i class="mdi mdi-block-helper mr-3"></i>Deprecated
        </h5>
        <p class="card-text">
          This category has been deprecated, please contact you administrator
          for more information.
          <a class="btn btn-light btn-sm" @click="$router.go(-1)">Go Back</a>
        </p>
      </b-card>
    </div>
  </div>
</template>
